import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 36">
        <path
          id="Icon"
          d="M6 0C6.55228 0 7 0.447715 7 1V2H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V2H16C17.1046 2 18 2.89543 18 4V17C18 18.1046 17.1046 19 16 19H2C0.895431 19 0 18.1046 0 17V4C0 2.89543 0.895431 2 2 2H5V1C5 0.447715 5.44772 0 6 0ZM5 4H2V7H16V4H13V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V4H7V5C7 5.55228 6.55228 6 6 6C5.44772 6 5 5.55228 5 5V4ZM16 9H2V17H16V9Z"
          fill="#0058A0"
        />
        <rect
          id="Rectangle 28"
          x="10"
          y="12"
          width="4"
          height="3"
          rx="0.5"
          fill="#0058A0"
        />
      </g>
    </svg>
  );
};
